import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { brandSourcesByName } from '@/contexts/brand/sources/brandSourcesByName';
import { resolveBrand } from '@/contexts/brand/sources/resolveBrand';
import { signedInLanding } from '@/lib/appBootstrap/signedInLanding';
import { isMobileViewport } from '@/lib/utils/isMobileViewport';
import { getValidAuthToken } from '@/utils/auth';

// gloss
const isMidAuth = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return params.has('token') || params.has('code') || params.get('clearCache') === 'true';
};

// gloss
export const useSignedInRedirect = (): void => {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined' || !router.isReady) return;
    if (isMidAuth(window.location.search)) return;
    if (!getValidAuthToken()) return;

    const { uuid, brandID, code } = resolveBrand(brandSourcesByName(['query', 'store', 'token']), {
      url: new URL(window.location.href),
      hostname: window.location.hostname,
    });

    router.replace(signedInLanding({ hasBrand: Boolean(uuid || brandID || code), isMobile: isMobileViewport() }));
  }, [router.isReady]); // eslint-disable-line react-hooks/exhaustive-deps -- fire once the router is ready
};
